import React from 'react';

import Button from './components/button';

import './app.scss';

export default () => (
  <div>
    <h1>Hello, World</h1>
    <Button>Press Me</Button>
  </div>
);
